import styled from "styled-components";

export const GradientBackdropContainer = styled.div`
    height: 100%;
    width: 100%;
    z-index: 101;
    position: fixed;
    background-image: linear-gradient(rgba(32,184,234,0.161), rgba(121,170,231,0));
    background-color: white;
    > img {
        position: fixed;
        bottom: 0;
        width: 100%;
    }
`;


// WEBPACK FOOTER //
// ./src/Components/GradientBackdrop/GradientBackdropStyle.js